import { 
    Text,
    Center,
    Container,
    Card,
    Title
} from '@mantine/core';

import { 
    IconCircleCheck
} from '@tabler/icons-react';

import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useViewportSize } from '@mantine/hooks';
import { useActivateUser } from '../api/activateUser';
import { Loading } from '@/components/Loading';
import { Error } from '@/components/Error/Error';
import { ERROR_CODES } from '@/types/error_codes';
import { IconAlertCircle } from '@tabler/icons-react';

export const ActivateUser = () => {
    const { t } = useTranslation();
    const { token, user_uuid } = useParams();
    const useActivateUserMutation = useActivateUser();
    const { height } = useViewportSize();

    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMesssage, setErrorMessage] = useState('');


    async function activateUser() {
        await useActivateUserMutation.mutateAsync({ user_uuid: user_uuid!, token: token!})
            .then(() => {
                setIsSuccess(true)
            })
            .catch((err: any) => {
                console.debug(err)
                if (err.response.data.studiocast.code === ERROR_CODES.USER_ALREADY_ACTIVATED)
                    setErrorMessage(t('error.userAlreadyActivated'))
                setIsError(true)
            })
    }

    useEffect(() => {
        activateUser()
    }, [])

    if (isError) {
        return (
            <Center maw={400} mx="auto" h={height}>
                <Container maw={400}>
                    <Card shadow="sm" padding="lg" radius="md" withBorder mb="md" mt="md">
                        <Center>
                            <IconAlertCircle color="blue" size={60} />
                        </Center>
                        <Title ta='center'>{t('activate.userActivated')}</Title>
                        <Error message={errorMesssage}/>
                        <Center>
                            <Link to={'/login'}>
                                <Text>{t('action.backToLogin')}</Text>
                            </Link>
                        </Center>
                    </Card>
                </Container>
            </Center>
        )
    }

    if (isSuccess) {
        return (
            <Center maw={400} mx="auto" h={height}>
                <Container maw={400}>
                    <Card shadow="sm" padding="lg" radius="md" withBorder mb="md" mt="md">
                        <Center>
                            <IconCircleCheck color="blue" size={60} />
                        </Center>
                        <Title ta='center'>{t('activate.userActivated')}</Title>
                        <Text ta='center'>{t('activate.userActivatedMessage')}</Text>
                        <Center>
                            <Link to={'/login'}>
                                <Text>{t('action.backToLogin')}</Text>
                            </Link>
                        </Center>
                    </Card>
                </Container>
            </Center>
        )
    }

    return (
        <>
            <Loading />
        </>
    )
}